module.exports = __webpack_public_path__ + "static/media/grasshopper.4a48a728.jpg";